import { useQuery } from "@tanstack/react-query";
import type { MemberRow } from "../../../server/routes/companies";
import { Badge, ErrorNotice, Panel, Spinner } from "../../components/ui";
import { api } from "../../lib/api";
import { useCompany } from "../../lib/company";
import { timeAgo } from "../../lib/format";

/** Everyone who has signed in, with their ServiceM8 role. */
export function PeopleSection() {
    const company = useCompany();
    const members = useQuery({
        queryKey: ["c", company.id, "admin", "members"],
        queryFn: () => api<MemberRow[]>(`/c/${company.id}/members`),
    });

    return (
        <Panel title="People" flush>
            <p className="px-5 pt-4 text-muted">
                Everyone who has signed in. Any active staff member in ServiceM8 can sign in with their ServiceM8 email;
                deactivating them in ServiceM8 removes their access.
            </p>
            {members.data === undefined ? (
                <div className="p-4">{members.error ? <ErrorNotice error={members.error} /> : <Spinner />}</div>
            ) : (
                <table className="list mt-2">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>ServiceM8 role</th>
                            <th>Last signed in</th>
                            <th />
                        </tr>
                    </thead>
                    <tbody>
                        {members.data.map((m) => (
                            <tr key={m.userId}>
                                <td>
                                    <div className="font-semibold">{m.name ?? m.email}</div>
                                    <div className="text-xs text-muted">{m.email}</div>
                                </td>
                                <td>{m.securityRole ?? <span className="text-muted">None</span>}</td>
                                <td className="whitespace-nowrap">{m.lastLoginAt ? timeAgo(Date.parse(m.lastLoginAt)) : "Never"}</td>
                                <td className="text-right">{m.canManage && <Badge tone="green">Manager</Badge>}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </Panel>
    );
}
